import React, { Component } from "react";
import * as designerActions from "../../redux/actions/designer";
import {
  Text,
  View,
  StyleSheet,
  Platform,
  Button as RNButton,
} from "react-native";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import MenuButton from "../../components/MenuButton";
import WebHeading from "../../components/WebHeading";
import goTo from "../../utils/goTo";
import { errorColors, RepositStyles } from "../../utils/styles";
import Icon from "react-native-vector-icons/FontAwesome";
import Selector from "../../components/Selector";

const NEW_INVERTER_OPTIONS = [1, 2, 3, 4, 5].map((el) => ({
  value: el,
  label: el === null ? null : el + " New Inverter" + (el === 1 ? "" : "s"),
}));

const EXISTING_INVERTER_OPTIONS = [1, 2, 3, 4, 5].map((el) => ({
  value: el,
  label: el === null ? null : el + " Existing Inverter" + (el === 1 ? "" : "s"),
}));

const GRID_PHASE_OPTIONS = [1, 2, 3].map((el) => ({
  value: el,
  label: el === null ? null : el + " Network Phase" + (el === 1 ? "" : "s"),
}));

const mapStateToProps = (state) => ({
  gridPhases: state.designer.kit.design.gridPhases,
  inverterSystems: state.designer.kit.design.inverterSystems,
  numExisting: state.designer.kit.design.numExisting,
});

const mapDispatchToProps = (dispatch) => {
  return {
    designerActions: bindActionCreators(designerActions, dispatch),
  };
};

const styles = StyleSheet.create({
  wrapper: { backgroundColor: "white", flex: 1 },
  heading: {
    marginHorizontal: 20,
  },
  headingText: { fontSize: 24, textAlign: "center", fontWeight: "300" },
  text: {
    textAlign: "left",
    fontSize: 18,
    lineHeight: 25,
    fontWeight: "300",
    marginHorizontal: 20,
    marginVertical: 20,
  },
  textInputTitle: {
    textAlign: "center",
    fontSize: 20,
    lineHeight: 25,
    fontWeight: "300",
  },
  bodyText: {
    marginVertical: 10,
  },
  textInput: {
    fontSize: 16,
    height: Platform.OS === "android" ? 40 : 25,
    textAlign: "center",
  },
  textInputWrapper: {
    alignItems: "center",
  },
  textInputContainer: {
    width: 300,
    borderBottomWidth: Platform.OS === "android" ? 0 : 1,
    borderBottomColor: "#D2D2D2",
  },
  pickerContainer: {
    width: "100%",
  },
  bodyTextContainer: {
    flex: 1,
    alignItems: "center",
  },
});

export class SiteDetails extends Component {
  constructor(props) {
    super(props);
    const { gridPhases, inverterSystems, numExisting } = props;
    const numNew =
      typeof numExisting === "number" &&
      Object.keys(inverterSystems).length - numExisting;
    this.state = {
      numExisting: numExisting,
      numNew: numNew,
      gridPhases: gridPhases.value,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { gridPhases, inverterSystems } = nextProps;

    const { numExisting, numNew } = this.state;

    const total = numExisting + numNew;

    const numSystems = Object.keys(inverterSystems).length;

    if (typeof total === "number" && total !== numSystems) {
      const newNumExisting =
        numSystems < numExisting ? numSystems : numExisting;
      const newNumNew = numSystems - newNumExisting;
      this.setState({
        numExisting: newNumExisting,
        numNew: newNumNew,
        gridPhases: gridPhases.value,
      });
    }
  }

  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "Site Details",
  };

  componentDidMount = () => {
    this.props.designerActions.fetchKitOptions();
  };

  handleGridPhasesChanged = (gridPhases) => {
    this.setState({
      gridPhases: gridPhases,
    });
  };

  handleNumInvertersChanged = (numExisting, numNew) => {
    this.setState({
      numExisting: numExisting,
      numNew: numNew,
    });
  };

  handleNext = () => {
    const { gridPhases, numExisting, numNew } = this.state;

    this.props.designerActions.updateNumInverterSystems(
      numExisting || 0,
      numNew || 0
    );
    if ([1, 2, 3].includes(gridPhases)) {
      this.props.designerActions.updateGridPhases(gridPhases, null);
      goTo(this.props.navigation, "InverterSets");
    } else {
      this.props.designerActions.updateGridPhases(
        null,
        "Please select the number of grid phases"
      );
    }
  };

  render() {
    const { gridPhases, numExisting, numNew } = this.state;
    const { error: gridPhasesError } = this.props.gridPhases;

    return (
      <View style={styles.wrapper}>
        <WebHeading title="Site Details" />
        <View style={{ flex: 1, alignItems: "center" }}>
          <View style={{ flex: 1, maxWidth: 800, maxHeight: 600 }}>
            <View style={{ flex: 5, justifyContent: "space-around" }}>
              <Text style={RepositStyles.paragraphText}>
                To get started building a Reposit Kit, tell us a little about
                the install premises
              </Text>
              <View style={styles.textInputWrapper}>
                <View style={styles.textInputContainer}>
                  <Selector
                    value={gridPhases}
                    options={GRID_PHASE_OPTIONS}
                    onChange={this.handleGridPhasesChanged}
                    placeholder="Network Phases"
                  />
                </View>
                {gridPhasesError && (
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      color: errorColors.orange,
                    }}
                  >
                    <Icon name="exclamation-circle" /> {gridPhasesError}
                  </Text>
                )}
              </View>
              <View style={styles.textInputWrapper}>
                <View style={styles.textInputContainer}>
                  <Selector
                    value={numExisting}
                    options={EXISTING_INVERTER_OPTIONS}
                    onChange={(value) =>
                      this.handleNumInvertersChanged(value, numNew)
                    }
                    placeholder="Number of Existing Inverters"
                  />
                </View>
              </View>
              <View style={styles.textInputWrapper}>
                <View style={styles.textInputContainer}>
                  <Selector
                    value={numNew}
                    options={NEW_INVERTER_OPTIONS}
                    onChange={(value) =>
                      this.handleNumInvertersChanged(numExisting, value)
                    }
                    placeholder="Number of New Inverters"
                  />
                </View>
              </View>
            </View>
            <View
              style={{
                flex: 2,
                justifyContent: "flex-end",
                alignItems: "center",
                marginBottom: -10,
              }}
            >
              <RNButton
                onPress={this.handleNext}
                title=" Next "
                color="#4698CB"
              ></RNButton>
              <Text style={RepositStyles.nextSub}>Inverters</Text>
            </View>
            <View style={{ flex: 1 }} />
          </View>
        </View>
      </View>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SiteDetails);



// WEBPACK FOOTER //
// ./src/containers/kit/SiteDetails.js